import { render } from "./Archive.vue?vue&type=template&id=226a081f"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__